import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams } from 'src/app/models';
import { LanguageService, NotificationService, ApiOrgDepartmentsService, ValidatorsService, ApiProductsService } from 'src/app/services';
import { OrgRoleEditValidator } from '../../organization/org-role-edit/org-role-edit.validation';

@Component({
  selector: 'app-attribute-model-for-product-table',
  templateUrl: './attribute-model-for-product-table.component.html',
  styleUrls: ['./attribute-model-for-product-table.component.css']
})
export class AttributeModelForProductTableComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  attributes: any[] = [];


  form: UntypedFormGroup = this.fb.group({
    attribute_id: [null]
  });

  @Input() set data(value) {

    if (value != null) {
      
      this.form.get('attribute_id').setValue(value.attributes);

    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiProducts: ApiProductsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getAttributes();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        access_type: 'read'
      }
    }

    this.subscriptions.add(
      this.apiProducts.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRS: ", response);


        if (response != null) {

          this.attributes = response.result;
        }
      })
    );

  }

  /**
   * 
   * @param attrsList 
   */
   onCreateAndSendAttrsData() {

    this.subscriptions.add(

      this.apiProducts.createUserAttributesListForDisplay({attributes: this.form.get('attribute_id').value}).subscribe((response: any) => {
        console.log("ATTRS: ", response);

        if (response.status == 1) {

          this.activeModal.close(true);

        }
      })
    );

  }
}
